import axios from 'axios';
import { PaginatedEvaluations } from '../types';

export const fetchEvaluationsList = async (): Promise<PaginatedEvaluations> => {
  return (await axios.get(`/v1/evaluation`)).data;
};
